Wee.fn.make('download', {
	init: function() {
		this.$private.download();
	},
	unload: function() {
		$.events.off(null, '.download');
	}
}, {
	download: function() {
		var scope = this,
			$downloadLink = jQuery('.funding__link.-download'),
			$form = jQuery('#fundingResultsPopup');

		$downloadLink.on('click.download', function() {
			$downloadLink.magnificPopup({
				items: {
					src: '#fundingResultsPopup',
					type: 'inline',
					preloader: false,
					focus: '#form-input-firstName'
				}
			}).magnificPopup('open');
		});

		$downloadLink.on('mfpAfterClose', function() {
			scope.resetForm($form);
		});

		$form.on('submit', function() {
			$form.hide();
			$form.after('<h3 class="form-submitted">Your customized PDF will begin downloading shortly...</h3>');
			setTimeout(function() {
				$downloadLink.magnificPopup('close');
			}, 5000);
		});
	},
	resetForm: function($form) {
		$form.show();
		$form.attr('disabled', false);
		$form[0].reset();
	}
});